import { UserType } from '@/types/user-story-carousel'
import Service, { getCallApiFunction } from '../service'

export type ParamsType = {
  queryTime?: string
  preferenceTag: string[] | string
  size: number
}
export type ResponseType = {
  vendorBlocks: UserType[]
}
class FetchExploreVendorBlockApi extends Service {
  constructor(params: ParamsType) {
    super()
    this.name = 'FETCH_EXPLORE_VENDER_BLOCK'
    this.config = {
      url: '/v1/livemall/feed/explore/vendor-block',
      method: 'GET',
      params,
    }
  }
}
export function fetchExploreVendorBlock(params: ParamsType): ResponseType {
  return getCallApiFunction(new FetchExploreVendorBlockApi(params))
}
